import React from "react";
import { graphql } from "gatsby";

import { ItemsGrid } from "../components/ItemsGrid";
import { EventsList } from "../components/EventsList";
import { ArticlesList } from "../components/ArticlesList";
import { SimpleHero } from "../components/SimpleHero";

import { organiseGreenhouseEvents } from "../utils/events";
import { organiseFeaturedPosts } from "../utils/utils";

const Events = props => {
  let {
    prismicEvents,
    allPrismicEvent,
    allGreenhouseJob,
    allPrismicBlogPost
  } = props.data;

  let events = organiseGreenhouseEvents(allGreenhouseJob, allPrismicEvent);
  let posts = organiseFeaturedPosts(prismicEvents.data.featured_posts);

  return (
    <div>
      <SimpleHero
        title={prismicEvents.data.title.text}
        heroImage={prismicEvents.data.hero_image.url}
        componentClass={"bg-green-bottom"}
      />

      <ItemsGrid
        title={prismicEvents.data.events_title.text}
        data={events}
        includeMustReads={false}
        componentClass={"bg-green"}
        linkType={"event"}
      />

      <EventsList events={events} componentClass={"bg-green"} />

      <ItemsGrid
        title={prismicEvents.data.articles_title.text}
        data={posts.slice(0, 3)}
        includeMustReads={false}
        linkType={"event"}
      />

      <ArticlesList articles={allPrismicBlogPost.nodes.slice(0, 10)} />
    </div>
  );
};

export default Events;

export const pageQuery = graphql`
  query EventsQuery {
    allGreenhouseJob(filter: { board_type: { eq: "event" } }) {
      nodes {
        gh_Id
        title
        content
        slug
        location {
          name
        }
      }
    }
    allPrismicBlogPost {
      nodes {
        uid
        data {
          title {
            text
          }
          narrator {
            text
          }
          medium_url {
            url
          }
        }
      }
    }
    allPrismicEvent {
      nodes {
        uid
        data {
          summary {
            text
          }
          title {
            text
          }
          thumbnail {
            url
            mobile {
              url
            }
          }
          start_date
          end_date
        }
      }
    }
    prismicEvents {
      id
      data {
        hero_image {
          url
          mobile {
            url
          }
        }
        title {
          text
        }
        articles_title {
          text
        }
        events_title {
          text
        }
        featured_posts {
          post {
            uid
            document {
              data {
                medium_url {
                  url
                }
                title {
                  text
                }
                summary {
                  text
                }
                role {
                  text
                }
                narrator {
                  text
                }
                image {
                  url
                  mobile {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
